import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';
import { BreakpointValues } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: [Spacings.s8, Spacings.s16],
      backgroundColor: BackgroundColors.base,
      position: 'sticky',
      top: 0,
      zIndex: StackingContext.LayoutLayer,
      [`@media (max-width: ${BreakpointValues.XS}px)`]: {
        padding: [Spacings.s8, Spacings.s12],
      },
    },
  },
  { name: 'header' }
);

export default useStyles;
